module.exports = __webpack_public_path__ + "static/media/ic_co_browse_disable.da71359a.svg";